import { createPageApp } from '@/lib/createPageApp'
import CabinetPage from './CabinetPage.vue'

createPageApp(CabinetPage).mount()
